import { useRef, useState } from 'react'
import styles from './VideoPlayer.module.css'
import playButton from './assets/play.png'
import fullScreenButton from './assets/fullscreen.png'

type VideoSources = {
    src: string
    type: string
}

interface videoPlayerPropsInterface {
    logo?: string | undefined
    poster?: string | undefined
    sources: VideoSources[]
}

export default function VideoPlayer(props: videoPlayerPropsInterface) {
    const { logo, poster, sources } = props
    const [ showOverlay, setShowOverlay ] = useState(true)
    const videoRef = useRef<HTMLVideoElement>(null)
    const showFullscreenButton = videoRef.current?.paused === false

    const handlePlayPause = () => {
        if(videoRef.current) {
            const video = videoRef.current

            if(video.paused) {
                video.play()
                setShowOverlay(false)
            }
            else {
                video.pause()
                setShowOverlay(true)
            }
        }
    }

    const handleFullScreenButtonOnClick: React.MouseEventHandler<HTMLImageElement>  = e => {
        e.preventDefault()

        if(videoRef.current) {
            const video = videoRef.current

            if(video.requestFullscreen) {
                video.requestFullscreen()
            }
            //@ts-ignore
            else if(video.mozRequestFullScreen) {
                //@ts-ignore
                video.mozRequestFullScreen()
            }
            //@ts-ignore
            else if(video.webkitRequestFullScreen) {
                //@ts-ignore
                video.webkitRequestFullScreen()
            }
            //@ts-ignore
            else if(video.webkitEnterFullScreen) {
                //@ts-ignore
                video.webkitEnterFullScreen()
            }
        }
    }

    let logoClassName = styles.logo
    let playButtonClassName = `${styles.button} ${styles.playButton}`
    let fullScreenButtonClassName = `${styles.button} ${styles.fullScreenButton}`

    if(showOverlay) {
        playButtonClassName += ' ' + styles.fadeIn
        logoClassName += ' ' + styles.fadeIn
    }
    else {
        playButtonClassName += ' ' + styles.fadeOut
        logoClassName += ' ' + styles.fadeOut
    }

    return (
        <section className={ styles.videoContainer }>
            {
                logo && logo.length > 0 && (
                    <img
                        alt={ logo.split('/').at(-1) }
                        src={ logo }
                        className={ `${logoClassName} mt-4 mt-sm-3 mt-md-2` }
                    />
                )
            }
            <video
                className={ styles.video }
                poster={ poster }
                ref={ videoRef }
                controls={ false }
                onClick={ e => {
                    e.preventDefault()
                    handlePlayPause()
                } }
                onEnded={ e => {
                    e.preventDefault()
                    setShowOverlay(true)
                    videoRef.current?.load()
                }}
            >
                {
                    sources.map((source, index) => {
                        const { src, type } = source
                        const key = `${index + 1}-${source.src.replaceAll('/', '-')}`

                        return <source key={ key } src={ src } type={ type } />
                    })
                }
            </video>

            <img
                alt={ 'Play' }
                src={ playButton }
                className={ playButtonClassName }
                onClick={ e => {
                    e.preventDefault()
                    handlePlayPause()
                } }
            />

            {
                showFullscreenButton && (
                    <img
                        alt='Toggle Fullscreen'
                        src={ fullScreenButton }
                        className={ fullScreenButtonClassName }
                        onClick={ handleFullScreenButtonOnClick }
                    />
                )
            }
        </section>
    )
}